import { gql } from '@apollo/client';
import { OTK_PROJ_UUID } from 'app-constants';
import { LoadOptions } from 'devextreme/data';

import { CustomStoreExt } from 'types/datatypes/classes';
import { ILab } from 'types/datatypes/ILab';
import { INom } from 'types/datatypes/INom';
import { TDoc_types } from 'types/IOptions';
import { ApolloAnswer } from 'types/otkTypes';
import { createDataSource } from 'utils/gql-datasource';

const dsGetNoms = gql(`query dsGetNoms($ref: String, $limit: Int, $offset: Int, $jfilt: [JSON], $jfiltJoined: [JSON], $userData: JSON) {
  totalcount: noms(ref: $ref, totalCount: 1, jfiltJoined: $jfiltJoined, userData: $userData) { totalcount }
  list: noms(ref: $ref, limit: $limit, offset: $offset, jfilt: $jfilt, jfiltJoined: $jfiltJoined, userData: $userData) {
    ref 
    name 
    name_full 
    vat_rate
    article
    doc_type
  }
}`);

export const dsNoms = createDataSource<INom>(dsGetNoms);

// Звужує список до дозволених для лабораторії ref-ів; якщо перетину нема — повертає весь список як є.
const restrictToAllowedRefs = (items: INom[], allowedRefs: string[]) => {
  if (!allowedRefs.length) return items;
  const filtered = items.filter((row) => allowedRefs.includes(row.ref));
  return filtered.length ? filtered : items;
};

export const dsProjNoms = <T=INom>(
  projRef:string,
  lab:ILab,
  doc_type:TDoc_types|null = null
  ): CustomStoreExt<T, any> => {

  const labServices = lab?.services?.map((row) => row.nom) ?? [];
  const dsProxy = Object.create(dsNoms);
  const projFilter = [ [ 'proj', '=', projRef ?? OTK_PROJ_UUID ], 'and', [ 'nom_type', '=', 'Услуга' ] ];

  dsProxy.load = (opt: LoadOptions<INom>) => dsNoms.load({ ...opt, filter: projFilter })
    .then((result) => {
      const { data } = result as unknown as ApolloAnswer<INom>;
      const items = restrictToAllowedRefs(data, labServices);
      return items.filter((row) => row?.doc_type === doc_type);
    });
  return dsProxy;
};

export const dsProjGoods = <T=INom>(
  projRef:string,
  lab:ILab,
  doc_type:TDoc_types|null = null
  ): CustomStoreExt<T, any> => {

  const labGoods = lab?.goods?.map((row) => row.nom) ?? [];
  const dsProxy = Object.create(dsNoms);
  const projFilter = [ [ 'proj', '=', projRef ?? OTK_PROJ_UUID ], 'and', [ 'nom_type', '=', 'Товар' ] ];

  dsProxy.load = (options: LoadOptions<INom>) => dsNoms.load({ ...options, filter: projFilter })
    .then((result) => {
      const { data } = result as unknown as ApolloAnswer<INom>;
      const items = restrictToAllowedRefs(data, labGoods);
      return items.filter((row) => row?.doc_type === doc_type);
    });
  return dsProxy;
};
